// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"dbcbebc1","360":"ef60c425","378":"90ad44a9","521":"ba8dd5ef","538":"fcfdc3c2","542":"8b2bc9f6","598":"43e9ea35","600":"1df0b9e4","666":"8b7479dc","744":"b0c63174","820":"28552259","931":"350d4c88","951":"9b7a9657"}[chunkId] + ".chunk.js";
};